import axios from 'axios'

const ResourceService = {
  async getList (params = {}) {
    return axios.get('admin/resources', { params })
  },

  async show (id) {
    return axios.get(`admin/resources/${id}`)
  },

  async store (data) {
    return axios.post('admin/resources', data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },

  async update (id, data) {
    return axios.put(`admin/resources/${id}`, data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },

  async destroy (id) {
    return axios.delete(`admin/resources/${id}`)
  },

  async viewFile (id) {
    return axios.get(`admin/resources/${id}/view-file`, {
      responseType: 'blob'
    })
  }
}

export default ResourceService
